// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"743":"df12d4fd","917":"b3520fab"}[chunkId] + ".chunk.js";
};